import { Component } from 'react';
import IconKategori from '../assets/ic_kategori.svg';
import IconCart from '../assets/ic_cart.svg';
import IconVoucher from '../assets/ic_voucher.svg';
import IconNotification from '../assets/ic_notification.svg';
import IconProfile from '../assets/ic_profile.svg';
import IconInvoice from '../assets/ic_invoice.svg';
import { Link, useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { createNewHeaders, executeGet, executePost, updateHeaders } from '../functions/Kubuku';
import { SEARCH_ALL, LIST_KATEOGRI } from '../api';

import { connect } from 'react-redux';
import { searchAction } from '../redux/actions';
var LogoHeader = localStorage.getItem("logo");// clientSettings.logo;
class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      scrolling: false,
      path: window.location.pathname,
      flagShow: false,
      keyword: '',
      flagShowRole: false,
      namaOutlet: '',
      placeholder: 'Cari di ' + localStorage.getItem('namaToko'),
      idInt: 0,
      doEx: false,
      data: [],
      showMain: false,
      contentData: [],
      title: "Kategori"
    }
    LogoHeader = localStorage.getItem("logo");

    var ficon = document.getElementById("favicon");
    ficon.href = localStorage.getItem("icon"); //"https://www.google.com/favicon.ico";

  }
  getListCategories = async () => {
    try {
      const flagOpen = localStorage.getItem('flagOpen');
      ////console.log("flagOpen = " + flagOpen);
      if (flagOpen != "1") {
        createNewHeaders('', '');
      } else {
        updateHeaders('', '');
      }

      const json = await executeGet(LIST_KATEOGRI);
      // //console.log("list_kategori = " + JSON.stringify(json));
      if (json.code == 200) {
        this.setState({
          data: json.data[0]
        }, () => {
          //console.log("getListKategori = " + JSON.stringify(this.state.data)); 
        });
      }
    } catch (error) {
      ////console.log(error);
      // this.setState({ isLoading: false, isError: true, msg: "Network Error!" });
    }
  }

  componentDidMount = () => {
    console.log("DIDMOUNT HEADER =============")
    // let admin_toko = localStorage.getItem('admin_toko');
    // if (admin_toko != "1") {
    //   this.setState({ flagShowRole: true });
    // }
    //alert(localStorage.getItem("logo"));
    this.setState({ namaOutlet: localStorage.getItem('namaOutlet') });
    //console.log(localStorage.getItem('beranda'));
    this.getListCategories();
  }

  componentDidUpdate = () => {
    ////console.log("componentUpdate");
    if (this.state.namaOutlet != localStorage.getItem('namaOutlet')) {
      this.setState({ namaOutlet: localStorage.getItem('namaOutlet') });
    }

  }

  openCategories = (id) => {
    this.setState({
      showMain: false
    });
    window.location.href = window.location.origin + '/categorieDetail/' + id;
  }

  toggleMenu = () => {
    if (this.state.showMain) {
      this.setState({
        showMain: false
      });
    } else {
      this.setState({
        showMain: true
      });
    }

  }

  showMenu = () => {
    this.setState({
      showMain: true
    });
  }
  hideMenu = () => {
    this.setState({
      showMain: false
    });
  }
  _handleKeyDown = async (e) => {
    if (e.key === 'Enter') {
      //console.log('do validate' + this.state.keyword);
      try {
        let formData = new FormData();
        formData.append("page", 1);
        formData.append("row", 30);
        formData.append("keyword", this.state.keyword);
        localStorage.setItem("beranda", localStorage.getItem('beranda'));
        updateHeaders();
        const json = await executePost(SEARCH_ALL, formData);
        if (json.code == 200) {
          this.props.searchAction(json);
          localStorage.setItem('dataKategori', JSON.stringify(json));
          this.props.navigate('/search');
          // window.location.href = window.location.origin +"/search";

        }
      } catch (error) {
        ////console.log(error);
        this.setState({ isError: true, errorMessage: "Network Error!" });
      }
    }
  }

  render() {

    return (
      <>
        {this.state.showMain &&
          <>
            <div className="block lg:hidden">
              <div className="w-full xl:w-[400px] xl:ml-[370px] xl:mt-[60px] mt-[59px] xl:mb-0 mb-[47px] z-50 justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none">
                <div className="relative w-full h-full xl:h-[100%]  mx-auto">
                  <div className="border-0 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                    <div className="dark:bg-white">
                      <div className="flex space-x-7">
                        <div className="w-full bg-white">
                          <div className="grid grid-cols-1 bg-white shadow-[0_5px_8px_3px_rgba(0,0,0,0.1)]">
                            {this.state.data.map(item => {
                              return (
                                <div className="flex bg-white cursor-pointer align-text-bottom  items-center pl-4 pb-2 pt-2 bg-opacity-30" onClick={() => this.openCategories(item.id_kategori)}>
                                  <div className='w-[48px] mr-4'>
                                    <img className='w-[40px] h-[40px] rounded-[50%] opacity-75' src={item.cover}></img>
                                  </div>
                                  <div className="h-[40px] bg-white text-l align-text-bottom flex text-greenWalangDark">
                                    {item.kategori}
                                  </div>

                                </div>
                              )
                            })}
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div onMouseLeave={() => this.hideMenu()} className="hidden lg:block">
              <div className="w-full xl:mt-[70px] mt-[59px] h-[80%] xl:mb-0 mb-[47px] z-50 justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none">
                <div className="relative w-full h-full mx-auto">
                  <div className="border-0 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                    <div onMouseLeave={() => this.hideMenu()} className="dark:bg-white">
                      <div className="flex space-x-7 ml-4 xl:ml-20 mr-20 mt-4 pb-8">
                        <div className="w-full bg-white">
                          <div className="grid grid-cols-3 bg-white">
                            {this.state.data.map(item => {
                              return (
                                <div className="flex bg-white cursor-pointer align-text-bottom  items-center pl-4 pb-2 pt-2 bg-opacity-30" onClick={() => this.openCategories(item.id_kategori)}>
                                  <div className='w-[48px] mr-4'>
                                    <img className='w-[40px] h-[40px] rounded-[50%] opacity-75' src={item.cover}></img>
                                  </div>
                                  <div className="h-[40px] bg-white text-sm align-text-bottom flex text-greenWalangDark">
                                    {item.kategori}
                                  </div>

                                </div>
                              )
                            })}
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        }

        <nav className=''>
          {
            this.state.path != '/login' && this.state.path != '/register' && this.state.path != '/resetPassword' && this.state.path.substring(0, 26) != '/resetPasswordConfirmation' &&
            <div>
              <>
                <style>
                  {`
                      .bg-greenWalang {
                        background-color: rgb(${localStorage.getItem('colorPrimary')} / var(--tw-bg-opacity));
                      }
                      .border-greenWalang {
                        --tw-border-opacity: 1;
                        border-color: ${localStorage.getItem('colorPrimary')};
                      }
                      .text-greenWalang {
                        --tw-text-opacity: 1;
                        color: rgb(${localStorage.getItem('colorPrimary')} / var(--tw-text-opacity));
                      }
                    `}

                </style>
              </>
              <div className="lg:px-8 px-4 lg:py-0 py-4 xl:px-24 flex items-center flex-wrap bg-white fixed w-full z-10 top-0 border-b border-grayWalang shadow-md bg-[#ffffff]">
                <div className="hidden lg:block w-3/12">
                  <div className="flex items-center flex-shrink-0 text-white">
                    <div className='flex items-center'>
                      <Link to={"/" + localStorage.getItem("beranda")}>

                        <img className='max-h-[72px]' src={LogoHeader} alt="" />

                      </Link>
                    </div>
                  </div>
                </div>

                <div className="hidden lg:block w-6/12 p-3">
                  <div className="flex justify-center items-center">
                    <div onClick={() => this.showMenu()} onMouseOver={() => this.showMenu()} className="pr-8 hidden lg:block">
                      <div className="text-greenWalang pr-4">
                        Kategori
                      </div>
                      <div className="text-black text-center text-[10px]">{localStorage.getItem('namaOutlet')}</div>
                    </div>

                    <div className="relative text-gray-600 focus-within:text-gray-400 lg:w-8/12 xs:w-12/12">
                      <span className="absolute inset-y-0 left-0 flex items-center pl-2">
                        <button type="submit" className="p-1 focus:outline-none focus:shadow-outline">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-[20px] w-[20px]" fill="none" viewBox="0 0 24 24" stroke="#E3E3E3">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                          </svg>
                        </button>
                      </span>

                      <input type="search" name="search" onChange={event => this.setState({ keyword: event.target.value })} onKeyDown={this._handleKeyDown} className="py-3 text-sm text-gray-900 pr-1 bg-transparent border-solid border-grayWalang border rounded-full pl-10 focus:outline-none focus:bg-white focus:text-gray-900 w-full" placeholder={this.state.placeholder} autoComplete="on" />

                    </div>

                  </div>

                </div>

                <div className="w-3/12 hidden lg:block">

                  <div className="flex justify-end space-x-6 items-center">
                    <Link to="/publicVoucher">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 4L8 20" stroke="#414141" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="2 3" />
                        <path d="M2 8.44444C2 5.98985 3.98985 4 6.44444 4H17.5556C20.0102 4 22 5.98985 22 8.44444C22 8.98773 21.6884 9.48288 21.1986 9.71798L20.7113 9.95192C18.993 10.7767 18.993 13.2233 20.7113 14.0481L21.1986 14.282C21.6884 14.5171 22 15.0123 22 15.5556C22 18.0102 20.0102 20 17.5556 20H6.44444C3.98985 20 2 18.0102 2 15.5556C2 15.0123 2.31157 14.5171 2.80135 14.282L3.28872 14.0481C5.00702 13.2233 5.00702 10.7767 3.28872 9.95192L2.80135 9.71798C2.31157 9.48288 2 8.98773 2 8.44444Z" stroke="#414141" strokeWidth="1.5" />
                        <path d="M13.0175 9.73737C13.3268 8.75421 14.6732 8.75421 14.9825 9.73737C15.1208 10.177 15.5174 10.4747 15.965 10.4747C16.9657 10.4747 17.3818 11.7976 16.5722 12.4052C16.2101 12.6769 16.0586 13.1586 16.1969 13.5983C16.5062 14.5814 15.4168 15.399 14.6072 14.7914C14.2451 14.5196 13.7549 14.5196 13.3928 14.7914C12.5832 15.399 11.4938 14.5814 11.8031 13.5983C11.9414 13.1586 11.7899 12.6769 11.4278 12.4052C10.6182 11.7976 11.0343 10.4747 12.035 10.4747C12.4826 10.4747 12.8792 10.177 13.0175 9.73737Z" stroke="#414141" strokeWidth="1.5" />
                      </svg>

                    </Link>
                    {localStorage.getItem("token") && <>
                      <Link to="/wishlist">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.167 6.31394C3.33933 5.75511 3.64801 5.23003 4.12138 4.7607C4.49409 4.39118 4.8809 4.14748 5.269 4M10.3342 2.45494C11.7289 1.57021 13.9814 0.7336 15.9266 2.71726C20.5441 7.42614 12.6255 16.5 9.00034 16.5C5.37522 16.5 -2.54341 7.42614 2.0741 2.71726C4.01925 0.733622 6.27169 1.57022 7.6664 2.45494C8.45448 2.95485 9.54615 2.95485 10.3342 2.45494Z" stroke="black" strokeWidth="1.25" strokeLinecap="round" />
                        </svg>
                      </Link>
                      <Link to="/cart">
                        <img className='w-[21px]' src={IconCart} alt="" />
                      </Link>
                      <Link to="/profile/transaksi">
                        <img className='w-[21px]' src={IconInvoice} alt="" />
                      </Link>

                      <Link to="/profile/notification">
                        <img className='w-4' src={IconNotification} alt="" />
                      </Link>
                    </>}
                    <Link to="/profile">
                      <img className='w-4' src={IconProfile} alt="" />
                    </Link>

                  </div>

                </div>
                <div className='w-[5%] block lg:hidden'>
                  <div className='cursor-pointer pr-4' onClick={() => this.toggleMenu()}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                  </div>
                </div>


                <div className="w-[70%] block lg:hidden ml-4">
                  <div className="relative text-gray-600 focus-within:text-gray-400 lg:w-8/12 xs:w-12/12">
                    <span className="absolute inset-y-0 left-0 flex items-center pl-2">
                      <button type="submit" className="p-1 focus:outline-none focus:shadow-outline">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-[16px] w-[16px]" fill="none" viewBox="0 0 24 24" stroke="#E3E3E3">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                      </button>
                    </span>

                    <input type="search" name="search" onChange={event => this.setState({ keyword: event.target.value })} onKeyDown={this._handleKeyDown} className="py-1 text-s text-gray-900 pr-4 bg-transparent border-solid border-grayWalang border rounded-full pl-10 focus:outline-none focus:bg-white focus:text-gray-900 w-full" placeholder={this.state.placeholder} autoomplete="on" />

                  </div>
                </div>

                <div className="w-[20%] block lg:hidden">
                  <div className="flex justify-end space-x-2">
                    <Link to="/publicVoucher">
                      <img className='w-[22px]' src={IconVoucher} alt="" />
                    </Link>
                    <Link to="/cart">
                      <img className='w-[21px]' src={IconCart} alt="" />
                    </Link>
                    {/* <Link to="/profile/notification">
                    <img className='w-4' src={IconNotification} alt="" />
                  </Link> */}
                  </div>

                </div>

              </div>


              {/* menu dibawah */}
              <div className="flex x-60 justify-center item-center block lg:hidden">
                <div className="leading-loose shadow-2xl bg-white bottom-[0px] fixed px-3 w-full z-20 py-2">
                  <div className="grid grid-cols-4">
                    <Link to={"/" + localStorage.getItem("beranda")} className="flex justify-center items-center">
                      <center>
                        <div className='flex flex-col'>
                          <div>
                            <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6.29367 3.96556C8.96048 2.028 10.2939 1.05923 11.8167 1.00336C11.9389 0.99888 12.0611 0.99888 12.1833 1.00336C13.7061 1.05923 15.0395 2.028 17.7063 3.96556C20.3732 5.90311 21.7066 6.87189 22.2303 8.30291C22.2723 8.41771 22.3101 8.534 22.3436 8.65157C22.761 10.1171 22.2517 11.6846 21.2331 14.8197L19.512 20.1164C19.2386 20.958 18.4543 21.5279 17.5694 21.5279C16.4412 21.5279 15.5267 20.6133 15.5267 19.4852V16.7363C15.5267 15.6778 14.6686 14.8197 13.6101 14.8197H10.3899C9.3314 14.8197 8.47329 15.6778 8.47329 16.7363V19.4852C8.47329 20.6133 7.55877 21.5279 6.43065 21.5279C5.54572 21.5279 4.76144 20.958 4.48798 20.1164L2.76696 14.8197C1.74832 11.6846 1.23901 10.1171 1.65645 8.65157C1.68994 8.534 1.72773 8.41771 1.76974 8.30291C2.29344 6.87189 3.62685 5.90311 6.29367 3.96556Z" fill="#2BC239" fillOpacity="0.2" />
                              <path d="M2.76696 14.8197L2.05366 15.0514L2.76696 14.8197ZM1.65645 8.65157L2.37776 8.85703L1.65645 8.65157ZM6.29367 3.96556L5.85283 3.3588L6.29367 3.96556ZM1.76974 8.30291L2.47405 8.56067L1.76974 8.30291ZM4.48798 20.1164L5.20127 19.8847L4.48798 20.1164ZM19.512 20.1164L18.7987 19.8847L19.512 20.1164ZM17.7063 3.96556L18.1472 3.3588L17.7063 3.96556ZM22.2303 8.30291L21.526 8.56067L22.2303 8.30291ZM21.2331 14.8197L21.9464 15.0514L21.2331 14.8197ZM22.3436 8.65157L21.6222 8.85703L22.3436 8.65157ZM12.1833 1.00336L12.1558 1.75286L12.1833 1.00336ZM11.8167 1.00336L11.8442 1.75286L11.8167 1.00336ZM20.5198 14.5879L18.7987 19.8847L20.2253 20.3482L21.9464 15.0514L20.5198 14.5879ZM5.20127 19.8847L3.48025 14.5879L2.05366 15.0514L3.77469 20.3482L5.20127 19.8847ZM16.2767 19.4852V16.7363H14.7767V19.4852H16.2767ZM7.72329 16.7363V19.4852H9.22329V16.7363H7.72329ZM10.3899 14.0697C8.91719 14.0697 7.72329 15.2636 7.72329 16.7363H9.22329C9.22329 16.092 9.74561 15.5697 10.3899 15.5697V14.0697ZM16.2767 16.7363C16.2767 15.2636 15.0828 14.0697 13.6101 14.0697V15.5697C14.2544 15.5697 14.7767 16.092 14.7767 16.7363H16.2767ZM6.43065 22.2779C7.97298 22.2779 9.22329 21.0276 9.22329 19.4852H7.72329C7.72329 20.1991 7.14456 20.7779 6.43065 20.7779V22.2779ZM17.5694 20.7779C16.8555 20.7779 16.2767 20.1991 16.2767 19.4852H14.7767C14.7767 21.0276 16.027 22.2779 17.5694 22.2779V20.7779ZM3.48025 14.5879C2.96589 13.0049 2.5995 11.874 2.40725 10.9558C2.21861 10.055 2.21454 9.43007 2.37776 8.85703L0.935142 8.44611C0.680922 9.33861 0.722785 10.2303 0.939095 11.2633C1.1518 12.2791 1.54938 13.4994 2.05366 15.0514L3.48025 14.5879ZM5.85283 3.3588C4.53261 4.31799 3.49365 5.07158 2.7245 5.76835C1.94232 6.47693 1.38435 7.17368 1.06542 8.04515L2.47405 8.56067C2.67883 8.00112 3.04942 7.49798 3.73157 6.88002C4.42676 6.25026 5.38791 5.55068 6.73451 4.57232L5.85283 3.3588ZM2.37776 8.85703C2.40622 8.7571 2.43834 8.65824 2.47405 8.56067L1.06542 8.04515C1.01711 8.17717 0.973652 8.31091 0.935142 8.44611L2.37776 8.85703ZM3.77469 20.3482C4.14855 21.4988 5.2208 22.2779 6.43065 22.2779V20.7779C5.87064 20.7779 5.37432 20.4173 5.20127 19.8847L3.77469 20.3482ZM18.7987 19.8847C18.6257 20.4173 18.1294 20.7779 17.5694 20.7779V22.2779C18.7792 22.2779 19.8515 21.4988 20.2253 20.3482L18.7987 19.8847ZM17.2655 4.57232C18.6121 5.55068 19.5733 6.25026 20.2684 6.88002C20.9506 7.49798 21.3212 8.00112 21.526 8.56067L22.9346 8.04515C22.6157 7.17368 22.0577 6.47693 21.2755 5.76835C20.5064 5.07158 19.4674 4.31799 18.1472 3.3588L17.2655 4.57232ZM21.9464 15.0514C22.4506 13.4994 22.8482 12.2791 23.0609 11.2633C23.2772 10.2303 23.3191 9.33861 23.0649 8.44611L21.6222 8.85703C21.7855 9.43007 21.7814 10.055 21.5928 10.9558C21.4005 11.874 21.0341 13.0049 20.5198 14.5879L21.9464 15.0514ZM21.526 8.56067C21.5617 8.65824 21.5938 8.75709 21.6222 8.85703L23.0649 8.44611C23.0264 8.31091 22.9829 8.17717 22.9346 8.04515L21.526 8.56067ZM18.1472 3.3588C16.827 2.3996 15.7892 1.64436 14.8889 1.12818C13.9733 0.603234 13.1382 0.287886 12.2108 0.253865L12.1558 1.75286C12.7512 1.7747 13.3443 1.97167 14.1428 2.42948C14.9566 2.89603 15.9189 3.59396 17.2655 4.57232L18.1472 3.3588ZM6.73451 4.57232C8.0811 3.59396 9.04345 2.89603 9.85722 2.42948C10.6557 1.97167 11.2488 1.7747 11.8442 1.75286L11.7892 0.253865C10.8618 0.287886 10.0268 0.603234 9.11115 1.12818C8.21081 1.64436 7.17305 2.3996 5.85283 3.3588L6.73451 4.57232ZM12.2108 0.253865C12.0703 0.248712 11.9297 0.248712 11.7892 0.253865L11.8442 1.75286C11.948 1.74905 12.052 1.74905 12.1558 1.75286L12.2108 0.253865ZM13.6101 14.0697H10.3899V15.5697H13.6101V14.0697Z" fill="#2BC239" />
                            </svg>
                          </div>
                          <div className='text-[9px]'>
                            Beranda
                          </div>
                        </div>
                      </center>
                    </Link>
                    <Link to="/wishlist" className="flex justify-center items-center">
                      <center>
                        <div className='flex flex-col'>
                          <div>
                            <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6.7887 4.70111C7.1759 4.55397 7.3705 4.1208 7.22336 3.73361C7.07622 3.34641 6.64306 3.1518 6.25586 3.29894C5.68511 3.51583 5.1333 3.86846 4.61708 4.38027C3.96274 5.02902 3.5268 5.7657 3.28318 6.55575C3.16112 6.95157 3.38305 7.37139 3.77887 7.49345C4.17469 7.61551 4.59451 7.39358 4.71657 6.99776C4.88653 6.4466 5.19143 5.9231 5.67318 5.44547C6.05146 5.07042 6.428 4.83818 6.7887 4.70111Z" fill="#2BC239" />
                              <path fillRule="evenodd" clipRule="evenodd" d="M19.8468 1.93563C18.5193 0.581794 17.0414 0.16297 15.6535 0.264573C14.3031 0.36343 13.087 0.9492 12.1988 1.51263C11.4984 1.95695 10.5014 1.95695 9.80091 1.51263C8.9127 0.949207 7.6966 0.363443 6.34624 0.264589C4.95834 0.162987 3.48046 0.581808 2.1529 1.93563C0.58562 3.53392 0.0939029 5.50695 0.291357 7.50271C0.486535 9.47548 1.35186 11.4809 2.50598 13.2579C3.66317 15.0396 5.14136 16.6393 6.62433 17.8008C8.07467 18.9368 9.65271 19.75 10.9999 19.75C12.3471 19.75 13.9251 18.9368 15.3754 17.8008C16.8584 16.6393 18.3366 15.0396 19.4938 13.2579C20.6479 11.4809 21.5132 9.47548 21.7084 7.50271C21.9058 5.50694 21.4141 3.53392 19.8468 1.93563ZM13.0023 2.77928C13.7877 2.28103 14.7599 1.834 15.763 1.76057C16.7285 1.68989 17.7692 1.95929 18.7758 2.98585C19.9791 4.21289 20.3774 5.71993 20.2157 7.35503C20.0516 9.01313 19.3084 10.7894 18.2358 12.4409C17.1663 14.0876 15.7996 15.5633 14.4505 16.6199C13.0688 17.7021 11.8278 18.25 10.9999 18.25C10.172 18.25 8.93093 17.7021 7.54926 16.6199C6.20021 15.5633 4.83348 14.0876 3.76394 12.4409C2.69132 10.7894 1.94812 9.01313 1.78407 7.35503C1.6223 5.71993 2.02067 4.21289 3.2239 2.98585C4.23053 1.95931 5.27119 1.6899 6.23672 1.76059C7.23978 1.83402 8.21197 2.28104 8.99742 2.77928C10.1883 3.53473 11.8114 3.53473 13.0023 2.77928Z" fill="#2BC239" />
                            </svg>
                          </div>
                          <div className='text-[9px]'>
                            Wishlist
                          </div>
                        </div>
                      </center>
                    </Link>
                    <Link to="/profile/transaksi" className="flex justify-center items-center">
                      <center>
                        <div className='flex flex-col'>
                          <div>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M11.5 7.75002C11.5 7.3358 11.1642 7.00002 10.75 7.00002H4.75C4.33579 7.00002 4 7.3358 4 7.75002C4 8.16423 4.33579 8.50002 4.75 8.50002H10.75C11.1642 8.50002 11.5 8.16423 11.5 7.75002Z" fill="#2BC239" />
                              <path d="M10.5 10.75C10.5 10.3358 10.1642 10 9.75 10H4.75C4.33579 10 4 10.3358 4 10.75C4 11.1642 4.33579 11.5 4.75 11.5H9.75C10.1642 11.5 10.5 11.1642 10.5 10.75Z" fill="#2BC239" />
                              <path d="M10.75 13C11.1642 13 11.5 13.3358 11.5 13.75C11.5 14.1642 11.1642 14.5 10.75 14.5H4.75C4.33579 14.5 4 14.1642 4 13.75C4 13.3358 4.33579 13 4.75 13H10.75Z" fill="#2BC239" />
                              <path fillRule="evenodd" clipRule="evenodd" d="M4 19.75H17C18.5188 19.75 19.75 18.5188 19.75 17V11.5C19.75 11.0858 19.4142 10.75 19 10.75H15.75V2.94321C15.75 1.51981 14.1411 0.691843 12.9828 1.51918L12.8078 1.64421C12.0273 2.2017 10.9701 2.19983 10.1859 1.63972C8.88206 0.70839 7.11794 0.70839 5.81407 1.63972C5.02992 2.19983 3.9727 2.2017 3.19221 1.64421L3.01717 1.51918C1.8589 0.691843 0.25 1.51981 0.25 2.94321V16C0.25 18.0711 1.92893 19.75 4 19.75ZM6.68593 2.86032C7.46825 2.30152 8.53175 2.30152 9.31407 2.86032C10.6161 3.79035 12.3739 3.79745 13.6796 2.86481L13.8547 2.73978C14.0202 2.62159 14.25 2.73987 14.25 2.94321V17C14.25 17.4501 14.3581 17.875 14.5499 18.25H4C2.75736 18.25 1.75 17.2427 1.75 16V2.94321C1.75 2.73987 1.97984 2.62159 2.14531 2.73978L2.32036 2.86481C3.62605 3.79745 5.3839 3.79034 6.68593 2.86032ZM15.75 17V12.25H18.25V17C18.25 17.6904 17.6904 18.25 17 18.25C16.3096 18.25 15.75 17.6904 15.75 17Z" fill="#2BC239" />
                            </svg>
                          </div>
                          <div className='text-[9px]'>
                            Transaksi
                          </div>
                        </div>
                      </center>
                    </Link>
                    <Link to="/profile-menu" className="flex justify-center items-center">
                      <center>
                        <div className='flex flex-col'>
                          <div>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fillRule="evenodd" clipRule="evenodd" d="M11 3.25C8.37665 3.25 6.25 5.37665 6.25 8C6.25 10.6234 8.37665 12.75 11 12.75C13.6234 12.75 15.75 10.6234 15.75 8C15.75 5.37665 13.6234 3.25 11 3.25ZM7.75 8C7.75 6.20507 9.20507 4.75 11 4.75C12.7949 4.75 14.25 6.20507 14.25 8C14.25 9.79493 12.7949 11.25 11 11.25C9.20507 11.25 7.75 9.79493 7.75 8Z" fill="#2BC239" />
                              <path fillRule="evenodd" clipRule="evenodd" d="M11 0.25C5.06294 0.25 0.25 5.06294 0.25 11C0.25 14.0485 1.51989 16.8016 3.55751 18.7571C5.48833 20.61 8.11182 21.75 11 21.75C13.8882 21.75 16.5117 20.61 18.4425 18.7571C20.4801 16.8016 21.75 14.0485 21.75 11C21.75 5.06294 16.9371 0.25 11 0.25ZM1.75 11C1.75 5.89137 5.89137 1.75 11 1.75C16.1086 1.75 20.25 5.89137 20.25 11C20.25 13.1948 19.4863 15.2103 18.2089 16.7966C17.4149 15.2828 15.8286 14.25 14 14.25H8C6.17143 14.25 4.58513 15.2828 3.79109 16.7966C2.51372 15.2103 1.75 13.1948 1.75 11ZM14 15.75C15.4339 15.75 16.6521 16.6792 17.0831 17.9685C15.4565 19.3898 13.3294 20.25 11 20.25C8.67062 20.25 6.54352 19.3898 4.91687 17.9685C5.34791 16.6792 6.56613 15.75 8 15.75H14Z" fill="#2BC239" />
                            </svg>
                          </div>
                          <div className='text-[9px]'>
                            Profile
                          </div>
                        </div>
                      </center>
                    </Link>
                  </div>

                </div>
              </div>

            </div>


          }
        </nav>
      </>
    );

  }
}

// export default Header;
function WithNavigate(props) {
  let navigate = useNavigate();
  return <Header {...props} navigate={navigate} />
}

const mapStateToProps = (state) => ({
  search: state.search
});

export default connect(mapStateToProps, { searchAction })(WithNavigate);
